var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"ad-sidebar"},_vm._l((_vm.navItems),function(item){return _c('button',{key:item.key,staticClass:"ad-side-item",class:{ active: item.key === _vm.activeKey },attrs:{"type":"button"},on:{"click":function($event){return _vm.onNav(item)}}},[_vm._v(" "+_vm._s(_vm.displayName(item))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }